import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, EMPLOYER, EMPLOYER_COMPANY_PROFILE } from "../../../common/URLs";


export const EmployerBasicDetails = async (details) => {
    const url = `${BASE_URL}/${EMPLOYER}/${EMPLOYER_COMPANY_PROFILE}`; // Proxy path
    try {
      const token = await fetchToken()
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(details),
      });
      const data = await response.json(); 
      // console.log("API Data", data);
      return data;
    } catch (error) {
      // console.log("error", error);
      throw error;
    }
  };